import { render, staticRenderFns } from "./DownloadBillingPdfModalPati.vue?vue&type=template&id=efd61a58&scoped=true&"
import script from "./DownloadBillingPdfModalPati.vue?vue&type=script&lang=js&"
export * from "./DownloadBillingPdfModalPati.vue?vue&type=script&lang=js&"
import style0 from "./DownloadBillingPdfModalPati.vue?vue&type=style&index=0&id=efd61a58&lang=scss&scoped=true&"
import style1 from "./DownloadBillingPdfModalPati.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd61a58",
  null
  
)

export default component.exports